'use strict';

import { STATUS_SUCCESS } from '@/constants/appConstants';
import ReferenceDataService from '@/services/referenceDataService';

const setAvailableTimeZones = ({ commit }, data) => {
  commit('setAvailableTimeZones', data);
};

const requestDefaultTimeZone = ({ commit }) => {
  return ReferenceDataService.getDefaultTimeZone().then(response => {
    if (response.status === STATUS_SUCCESS) {
      commit('setDefaultTimeZone', response.data.name);
    }
    return response;
  });
};

/* This section should add ringtones from ASSETS */
/* The following ringtones are from: https://notificationsounds.com */
/* This ringtones will be used as POC until define the deliverable ringtones. */
const requestIncomingInteractionRingtones = ({ commit }) => {
  const addRingtone = (assetSrc, label, value) => {
    commit('addIncomingInteractionRingtone', {
      label,
      value,
      src: assetSrc
    });
  };

  addRingtone(require('@/assets/ringtones/bright_day.mp3'), 'Bright Day', 'brightDay');
  addRingtone(require('@/assets/ringtones/lovingly.mp3'), 'Lovingly', 'lovingly');
  addRingtone(require('@/assets/ringtones/slow_spring_board.mp3'), 'Slow Spring Board', 'slowSpringBoard');
  addRingtone(require('@/assets/ringtones/solemn.mp3'), 'Solemn', 'solemn');
};

const requestAvailableAgentStates = ({ commit }) => {
  return ReferenceDataService.getAvailableAgentStates().then(response => {
    if (response.status === STATUS_SUCCESS) {
      commit('setAvailableAgentStates', response.data);
    }
    return response;
  });
};

const requestValueSets = ({ commit }) => {
  return ReferenceDataService.getValueSets().then(response => {
    if (response.status === STATUS_SUCCESS) {
      commit('setValueSets', response.data);
    }
    return response;
  });
};

const requestAvailableAgentCustomBreakStates = ({ commit }) => {
  return ReferenceDataService.getAvailableAgentCustomBreakStates().then(response => {
    if (response.status === STATUS_SUCCESS) {
      commit('setAvailableAgentCustomBreakStates', response.data);
    }
    return response;
  });
};

const requestSupervisorKPIsDescription = ({ commit }) => {
  return ReferenceDataService.getSupervisorKPIsDescription().then(response => {
    if (response.status === STATUS_SUCCESS) {
      commit('setSupervisorKPIsDescription', response.data);
    }
    return response;
  });
};

const setSmtpDetails = ({ commit }, data) => {
  commit('setSmtpDetails', data);
};

const setSmsDetails = ({ commit }, data) => {
  commit('setSmsDetails', data);
};

export default {
  setAvailableTimeZones,
  requestDefaultTimeZone,
  requestIncomingInteractionRingtones,
  requestAvailableAgentStates,
  requestAvailableAgentCustomBreakStates,
  requestValueSets,
  requestSupervisorKPIsDescription,
  setSmtpDetails,
  setSmsDetails
};
